export default __webpack_public_path__ + "images/icons/chevron-left-90e1af591c439c5ea89d442ffe8eca00.svg";